/**
 * @author: subhasish.ghosh@zoom.us
 */

const geoChartOptions = {
  colorAxis: { colors: ["#ed8a8a", "#7b1919"] },
};

export default geoChartOptions;
